import { useFormContext as u, Controller as s } from "../../node_modules/react-hook-form/dist/index.esm.js";
import "../../UI/style.js";
import "../../node_modules/classnames/index.js";
import "../../UI/FormGrid/formGrid2.js";
import { jsx as m } from "../../_virtual/jsx-runtime.js";
import { UIInputContainer as C } from "../../UI/FormGrid/InputContainer.js";
import "../../UI/Input/UIInputText.js";
import { UIInputDate as I } from "../../UI/Input/UIInputDate.js";
import "../../UI/Input/UIInputCheckbox.js";
import "../../UI/Input/UIInputFile.js";
import "../../UI/Input/UIInputTextArea.js";
import "../../UI/Blocks/Button/Button.js";
import "../../UI/Blocks/Emphasis/emphasis2.js";
import "../../UI/Blocks/Card/card2.js";
import "react";
import "../../UI/Blocks/Toaster/toast2.js";
import "../../UI/Blocks/Toaster/toaster2.js";
function k({
  name: n,
  onChange: p,
  label: e,
  className: i,
  variant: r = "medium"
}) {
  const {
    control: a
  } = u();
  return /* @__PURE__ */ m(s, {
    name: n,
    control: a,
    render: ({
      field: o,
      fieldState: {
        error: t
      }
    }) => /* @__PURE__ */ m(C, {
      name: o.name,
      label: e,
      size: r,
      errorMessage: t == null ? void 0 : t.message,
      children: /* @__PURE__ */ m(I, {
        hasError: !!t,
        ref: o.ref,
        name: o.name,
        variant: r,
        className: i,
        value: o.value,
        onChange: p || o.onChange,
        onBlur: o.onBlur
      })
    })
  });
}
export {
  k as InputDate
};
//# sourceMappingURL=InputDate.js.map
